export const Genders = [
    {
        "id": "83ec390e-ac4f-4cd1-86a4-e4434e85748d",
        "name": "Male"
    },
    {
        "id": "14b45c13-923a-4827-8684-5d7bbb87dd58",
        "name": "Female"
    },
    {
        "id": "b379972b-ea9a-4524-bf61-12dbff569a3d",
        "name": "Prefer Not to Say"
    }
]